import React, { useEffect } from 'react';
import { motion, useAnimation } from 'framer-motion';
import styles from './ProgressBar.module.css';

const ProgressBar = ({ onComplete }) => {
  const controls = useAnimation();

  useEffect(() => {
    async function animate() {
      await controls.start({ width: '50%', transition: { duration: 0.5 } });
      await controls.start({ width: '90%', transition: { duration: 1 } });
      await controls.start({ width: '100%', transition: { duration: 0.4 } });
      onComplete();  // callback when 100% is reached
    }
    animate();
  }, [controls, onComplete]);

  return (
    <div className={styles.container}>
      <motion.div
        className={styles.bar}
        initial={{ width: 0 }}
        animate={controls}
      />
    </div>
  );
};

export default ProgressBar;
